import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, ProviderToken, inject } from '@angular/core';
import { map } from 'rxjs/operators';

// Implementing a Retry-Circuit breaker policy
// is pending to do for the SPA app
@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  apiUrl: string;
  tenant: string;
  clientID: string;
  signInPolicy: string;
  passwordResetPolicy: string;
  redirectUri: string;
  b2cScopes: string[];
  navigateToLoginRequestUrl: boolean;
  msal: any;
  private http: HttpClient;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private readonly httpHandler: HttpBackend
  ) {
    this.http = new HttpClient(httpHandler);
    this.apiUrl = this.baseUrl;
  }

  public init(endpoint: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http
        .get(endpoint)
        .pipe(map((result) => result))
        .subscribe(
          (value) => {
            const config = value as ConfigurationService;
            this.apiUrl = config.apiUrl;
            this.clientID = config.clientID;
            this.tenant = config.tenant;
            this.signInPolicy = config.signInPolicy;
            this.passwordResetPolicy = config.passwordResetPolicy;
            this.redirectUri = config.redirectUri;
            this.b2cScopes = config.b2cScopes;
            this.navigateToLoginRequestUrl = config.navigateToLoginRequestUrl;
            this.msal = config.msal;
            resolve(true);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public getApiUrl() {
    if (this.apiUrl) {
      return this.apiUrl;
    }
  }

  public getMsalSettings(key?: string | Array<string>): any {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.msal;
    }

    if (!Array.isArray(key)) {
      key = key.split('.');
    }

    const result = key.reduce((account: any, current: string) => account && account[current], this.msal);

    return result;
  }
}
